import { Button } from "@stockline/ui/components/button";
import { Trash2 } from "lucide-react";
import { useTranslation } from "react-i18next";
import type { ActionsCellProps } from "./types";

/**
 * Direct delete button — the previous Radix `DropdownMenu` wrapper only
 * housed a single "Delete" item (per-row AI suggestions now resolve at
 * the header level via Accept/Decline, so no other actions need to live
 * here). The wrapper was paying a per-row Radix Presence mount cost for
 * a control that's just a delete shortcut. Click directly deletes; the
 * Trash2 icon + red tint signal the destructive nature.
 */
export function ActionsCell({
  flow,
  disabled,
  onFlowDelete,
}: ActionsCellProps) {
  const { t } = useTranslation();

  if (disabled) return null;

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={(e) => {
        e.stopPropagation();
        onFlowDelete(flow.id);
      }}
      className="h-8 w-8 p-0 text-gray-400 hover:text-red-600 hover:bg-red-50"
      title={t("ordersRecap.delete")}
      aria-label={t("ordersRecap.delete")}
      data-testid={`flow-actions-delete-${flow.id}`}
      // Stable, id-independent handle for the guidance overlay's "delete a
      // line" step — the per-row testid above is keyed on the flow id, so it
      // can't be a fixed guide target; the overlay spotlights the first match.
      data-attr="flow-actions-delete"
    >
      <Trash2 className="h-4 w-4" />
    </Button>
  );
}
